import moment from 'moment';
import { safeParseJson } from '../../lib';
import {
  CommonStatusStep,
  IAPICompanyFullInfo,
  IAPICompanyRes,
  ICertInfo,
  StudioCertifiedType,
} from '../../model/api-modules';

export const getReformCompanyInfo = (res: IAPICompanyRes | null) => {
  const getLastCertInfo = () => {
    if (!res) {
      return;
    }
    return moment(res.approval?.ModifyTime || '1990-1-1').isBefore(
      moment(res.studioCertRes?.ModifyTime || '1990-1-1')
    )
      ? res.studioCertRes
      : res.company;
  };

  const getLastCertType = () => {
    const lastInfo = getLastCertInfo();
    if (!lastInfo) {
      return;
    }

    return 'CertInfo' in lastInfo
      ? StudioCertifiedType.InternalKpiCode
      : StudioCertifiedType.Company;
  };

  if (res?.company || res?.studioCertRes) {
    const validateInfo = getLastCertInfo();

    if (validateInfo) {
      const data: IAPICompanyFullInfo = {
        id: 0,
        StudioID: '0',
        ...(res.approval || {}),
        ...(res.company || {}),
        ...(res.studioCertRes || {}),
        InternalCertInfo: safeParseJson<ICertInfo>(res.studioCertRes?.CertInfo),

        studioCertRes: res.studioCertRes,
        isCertified: validateInfo.Status === CommonStatusStep.Resolve,
        lastCertifiedType: getLastCertType(),
        certifiedType:
          validateInfo.Status === CommonStatusStep.Resolve
            ? getLastCertType()
            : undefined,
        mdmUnderReview: res.mdmUnderReview,
        RejectReason:
          'CreditCode' in validateInfo
            ? res.approval?.ManualRejectReason
            : validateInfo?.RejectReason,
        Status: validateInfo?.Status || CommonStatusStep.Pending,
      };
      return data;
    }
  }

  return null;
};
